import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class EcallService {

  constructor(private http: HttpClient) { }
  uploadPDF(id, file, description): Observable<any> {

    var formData = new FormData();
    formData.append('speicalServiceReports', file);
    let httpParams = new HttpParams();
    if(description) {
      httpParams = httpParams.append('description', description);
    }
    return this.http.post(environment.appUrl + 'service-report/speicalServiceReports/type/0/serviceId/' + id + '/image', formData, { params: httpParams, observe: 'body', withCredentials: true});
  }
  deletePDF(id, fileId): Observable<any> {
    return this.http.delete(environment.appUrl + 'service-report/speicalServiceReports/type/0/serviceId/' + id+ '/specialFormId/' + fileId +'/delete', {observe: 'body', withCredentials: true});
  }
  getPDFs(id): Observable<any> {
    return this.http.get(environment.appUrl + 'service-report/speicalServiceReports/type/0/serviceId/' + id, {observe: 'body', withCredentials: true});
  }

  downloadServiceReport(serviceReportId): Observable<any> {
    // return Observable.of(1).delay(3000);
    const url = environment.appUrl + `forms/service-report/specialFormId/${serviceReportId}/pdf`;
    return this.http.get(url, {
      observe: 'response',
      responseType: 'blob'
    })
    .map(res => {
      if (res.status === 200) {
        return {
          file: res.body,
          fileName: res.headers.get('content-disposition').replace('attachment;filename=', '')
        };
      } else {
        return Observable.throw(null);
      }
    })
    .catch(err => {
      return Observable.throw(err);
    });
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/ecall/ecall.service.ts